export default {
  placeholder: 'All',
};
